import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
  Box,
  Grid,
  Paper,
  Button,
  Backdrop,
  CircularProgress,
  FormControlLabel,
  Switch,
  Popover,
  Tooltip,
  Checkbox,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { display } from '../../redux/reducers/sidebar';
import { LocalPrintshop, OpenInFull, MoreVert, CloseFullscreen, WarningAmber } from '@mui/icons-material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { alpha, styled } from '@mui/material/styles';
import Menubar from '../../components/menubar/Menubar';
import ReceivablesTable from './components/ReceivablesTable.jsx';

import { API, graphqlOperation } from 'aws-amplify';
import arrayToTree from 'array-to-tree';

import moment from 'moment';

import { skipNotSave, skipSave } from '../../redux/reducers/companySkipSave';
import { skipFalse, skipOpen } from '../../redux/reducers/companySkip';
import { createUserPreference, updateUserPreference } from '../../graphql/mutations';
import { nonGst } from '../../redux/reducers/gstStatus';

import DbExportButton from '../../components/Buttons/DbExportButton';
import ExportModal from '../../components/modals/ExportModal';

import BusinessOverview from '../../components/DashboardComponents/BizView.jsx';
import { generateDashboardPrintableTable } from '../../utils/DashboardPrint';
import {
  setDbDateRange,
  setResetDashboard,
  setResetPeriod,
  setSwitchVertical,
  setTableRowCount2,
} from '../../redux/reducers/DashboardSlice';

import DbReloadBtn from '../../components/Buttons/DbReloadBtn';

import ItemNewTable from '../../components/DashboardComponents/ItemNewTable';
import { useFetchTrialBalanceDataQuery } from '../../redux/apis/trailBalance.api';
import { useFetchDashboardDataQuery, useFetchTotalClosingStockQuery } from '../../redux/apis/dashboardApi';
import { useListGroupMasterQuery } from '../../redux/apis/accountGroupMaster.api';
import { constructHierarchicalAccountTree, flattenTree } from '../../utils/common';
import TrailBalanceTable from './components/TrailBalanceTable.jsx';
import { useThemes } from '../../components/Theme/theme';
import AIBlinkButton from '../../components/Buttons/AIBlinkButton';
import SimpleModal from '../../components/modals/simpleModal';
import { axiosInstanceForLambda } from '../../library/Axios';
import { Buffer } from 'buffer';
import { LedgerTransactionModalv2 } from '../LedgerTransaction';
import { useTransactionModalHandle } from '../LedgerTransaction/hooks/useTransactionModalOpen';
import { showErrorSnackbar, showWarningSnackbar } from '../../components/snackBar/snakbar';
import BalanceSheetTableNew from './components/BalanceSheetTableNew.jsx';
import ProfitNLossTableNew from './components/ProfitNLossTableNew.jsx';
import API_ENDPOINTS from '../../apiEndpoints.js';
import RotateScreen from '../../components/modals/RotateScreen.jsx';
import dayjs from 'dayjs';
import { useListAccountOpeningBalanceQuery } from '../../redux/apis/accountOpeningBalance.api.js';
import { setNavigationBlocked } from '../../redux/reducers/controllNavigation';
import DashboardPeriodSelector from './components/DashboardPeriodSelector';
import ActionItems from '../NewFigma/newReports/actionItems';

function DashboardHome() {
  const { theme } = useThemes();
  const dispatch = useDispatch();
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [aiModal, setAIModal] = useState(false);
  const [aiModalLoading, setAIModalLoading] = useState(false);
  const [aisummary, setAISummary] = useState('');
  const [rowsIncome, setRowsIncome] = useState([]);
  const [rowsExpense, setRowsExpense] = useState([]);
  const [openingStock, setOpeningStock] = useState({});
  const [secondDataIncome, setSecondDataIncome] = useState([]);
  const [secondDataExpense, setSecondDataExpense] = useState([]);
  const [rowsLiabilities, setRowsLiabilities] = useState([]);
  const [openingDiffenerenceLedger, setOpeningBalanceLedger] = useState();
  const [totalTradingExpense, setTotalTradingExpense] = useState();
  const [rowsAssets, setRowAssets] = useState([]);
  const [receivables, setreceivables] = useState([]);
  const [expandPandLClicked, setExpandPandLClicked] = useState(true);
  const [expandBSClicked, setExpandBSClicked] = useState(true);
  const [expandTBClicked, setExpandTBClicked] = useState(true);
  const [expandRecClicked, setExpandRecClicked] = useState(true);
  const [expandPayClicked, setExpandPayClicked] = useState(true);
  const [expandItemClicked, setExpandItemClicked] = useState(true);
  const [TBrowsLiabilities, setTBrowsLiabilities] = useState([]);
  const [hideToggleClicked, sethideToggleClicked] = useState(false);
  const [hideSumToggleClicked, sethideSumToggleClicked] = useState(false);
  const [hideItemToggleClicked, sethideItemToggleClicked] = useState(false);
  const [hideItemSumToggleClicked, sethideItemSumToggleClicked] = useState(false);
  const [hidePandLToggleClicked, sethidePandLToggleClicked] = useState(false);
  const [hidePandLSumToggleClicked, sethidePandLSumToggleClicked] = useState(false);
  const [hideBSToggleClicked, sethideBSToggleClicked] = useState(false);
  const [hideBSSumToggleClicked, sethideBSSumToggleClicked] = useState(false);
  const [hideRecToggleClicked, sethideRecToggleClicked] = useState(false);
  const [hideRecSumToggleClicked, sethideRecSumToggleClicked] = useState(false);
  const [hidePayToggleClicked, sethidePayToggleClicked] = useState(false);
  const [hidePaySumToggleClicked, sethidePaySumToggleClicked] = useState(false);
  const [totalCredit, settotalCredit] = useState(0);
  const [totalDebit, settotalDebit] = useState(0);
  const [firstTotal, setFirstTotal] = useState(0);
  const [netIncomeProfit, setNetIncomeProfit] = useState(0);
  const [netExpenseProfit, setNetExpenseProfit] = useState(0);
  const [netIncomeloss, setNetIncomeLoss] = useState(0);
  const [netExpenseloss, setNetExpenseLoss] = useState(0);
  const [grossIncomeProfit, setgrossIncomeProfit] = useState(0);
  const [grossExpenseProfit, setgrossExpenseProfit] = useState(0);
  const [grossIncomeloss, setgrossIncomeLoss] = useState(0);
  const [grossExpenseloss, setgrossExpenseLoss] = useState(0);
  const [grossbdIncomeProfit, setgrossbdIncomeProfit] = useState(0);
  const [grossbdExpenseProfit, setgrossbdExpenseProfit] = useState(0);
  const [grossbdIncomeloss, setgrossbdIncomeLoss] = useState(0);
  const [grossbdExpenseloss, setgrossbdExpenseLoss] = useState(0);
  const [protitOrLoss, setProfitOrLoss] = useState('');
  const [grossprotitOrLoss, setGrossProfitOrLoss] = useState('');
  const [grossbdprotitOrLoss, setGrossbdProfitOrLoss] = useState('');
  const [pandLTotal, setpandLTotal] = useState(0);
  const [BsGroups, setBSGroups] = useState([]);
  const [profitnLossClicked, setProfitnLossClicked] = useState(false);
  const [businessOverviewCkicked, setBusinessOverviewCkicked] = useState(true);
  const [balanceSheetClicked, setBalanceSheetCkicked] = useState(false);
  const [receivableClicked, setReceivableClicked] = useState(false);
  const [payableClicked, setPayableClicked] = useState(false);
  const [trailBalanceClicked, setTrailBalanceClicked] = useState(false);
  const [itemsClicked, setItemsClicked] = useState(false);
  const [searchFilterPayables, setSearchFilterPayables] = useState('all');
  const [itemRow, setItemRow] = useState([]);
  const [searchFilterTrialBalance, setSearchFilterTrialBalance] = useState('all');
  const [anchorEl, setAnchorEl] = useState(null);
  const [groups, setgroups] = useState([]);
  const [headGroupsIncome, setHEadGroupsIncome] = useState([]);
  const [headGroupsExpense, setHEadGroupsExpense] = useState([]);
  const [DateRangeText, setDateRangeText] = useState('');
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;
  const userPreferencesState = useSelector((state) => state.userPrefrenceandReducer);
  const matches = useMediaQuery('(max-width:600px)');
  let thisYear;

  if (currentMonth >= 4) {
    thisYear = currentYear;
  } else {
    thisYear = currentYear - 1;
  }

  const [openingBalance, setOpeningBalance] = useState({
    TrialBalance: true,
    BalanceSheet: true,
    ProfitAndLoss: true,
    Receivables: true,
    Payables: true,
  });

  const [displayOpeningBalance, setDisplayOpeningBalance] = useState({
    TrialBalance: false,
    BalanceSheet: false,
    Receivables: false,
    Payables: false,
    ProfitAndLoss: false,
  });

  const [dashboardata, setDashboardData] = useState([]);

  const [rowsMaxWidth, setRowsMaxWidth] = useState({
    cell1: 0,
    cell2: 0,
  });

  const [tableRowDiff, setTableRowDiff] = useState({
    tableOne: 0,
    tableTwo: 0,
  });

  const [openRotate, setOpenRotate] = useState(true);

  var date = new Date(),
    y = date.getFullYear();

  const [newLedgerResponse, setNewLedgerResponse] = useState([]);
  const [totalRecRender, settotalRecRender] = useState(false);
  const [isFinancialYearAvailable, setIsFinancialYearAvailable] = useState(false);
  const [closingstockdate, setClosingstockdate] = useState('');
  const [selectedParentId, setSelectedParentId] = useState('');

  const [closingStockValue, setClosingStockValue] = useState(0);

  const [isCustomDateModalOpen, setIsCustomDateModalOpen] = useState(false);
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const { transactionModalParams, openTransactionModal } = useTransactionModalHandle();

  // Function to handle opening transaction modal with account ID

  let [searchParams, setSearchParams] = useSearchParams();

  let active = searchParams.get('active');
  const dashboardData = useSelector((state) => state?.DashboardDataReducer);

  const userPrefrenceandFY = useSelector((state) => state.userPrefrenceandReducer);

  const { startTimeStamp: dbStartDate, endTimeStamp: dbEndDate } =
    (profitnLossClicked || itemsClicked ? dashboardData?.pandlPeriod : dashboardData?.bsPeriod) || {};

  const companyReducer = useSelector((state) => state.companyReducer);

  // Loading states for proper loading management
  const isCompanyLoaded = useSelector((state) => state.companyReducer.Loaded);
  const isUserPreferenceLoading = useSelector((state) => state.userPrefrenceandReducer.loading);

  const dashboardVariables = useRef();
  dashboardVariables.current =
    dbStartDate && dbEndDate
      ? {
          startdate: dbStartDate,
          enddate: dbEndDate,
          openingbalance: profitnLossClicked
            ? openingBalance.ProfitAndLoss
              ? 1
              : 0
            : balanceSheetClicked
            ? openingBalance.BalanceSheet
              ? 1
              : 0
            : openingBalance.TrialBalance
            ? 1
            : 0,
          companyid: companyReducer.companyDetails?.companyid,
          financialyearid: userPrefrenceandFY?.financialYear?.financialyearid,
        }
      : null;

  const areQueryVariablesValid = dashboardVariables.current
    ? Object.values(dashboardVariables.current).every((value) => value !== undefined && value !== null)
    : false;

  // Combined loading state - show loading until both company and user preferences are loaded
  const isInitialDataLoading = !isCompanyLoaded || isUserPreferenceLoading;

  // new api
  const {
    data: dashboardApiData,
    isLoading,
    refetch: refetchDashboard,
    isFetching,
  } = useFetchDashboardDataQuery(dashboardVariables.current, {
    skip: !areQueryVariablesValid || businessOverviewCkicked,
  });

  const { data: totalClosingStock = [], isLoading: isLoadingClosingStock } = useFetchTotalClosingStockQuery(
    {
      endtimestamp: dashboardVariables?.current?.enddate,
      financialyearid: dashboardVariables?.current?.financialyearid,
    },
    { skip: !areQueryVariablesValid || businessOverviewCkicked }
  );

  const { data: groupData, refetch: refetchGroupMaster } = useListGroupMasterQuery(undefined, {
    skip: !areQueryVariablesValid,
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (matches) {
      setExpandPandLClicked(false);
      setExpandBSClicked(false);
      setExpandRecClicked(false);
      setExpandPayClicked(false);
      setExpandTBClicked(false);
      setExpandItemClicked(false);
    }
  }, [matches]);

  const setAccountID = (accountId) => {
    if (accountId) {
      openTransactionModal({
        accountId: accountId,
        startDate: dashboardVariables.current?.startdate || null,
        endDate: dashboardVariables?.current?.enddate || null,
        includingOpeningBalance: dashboardVariables?.current?.openingbalance === 1,
      });
    }
  };

  const tabKey = useMemo(() => {
    if (profitnLossClicked) {
      return {
        key: 'ProfitAndLoss',
        opWarningCondition: openingBalance?.ProfitAndLoss,
        hideZeroLedgerState: hidePandLToggleClicked,
        setHideZeroLedgerState: sethidePandLToggleClicked,
        hideGroupTotal: hidePandLSumToggleClicked,
        setHideGroupTotal: sethidePandLSumToggleClicked,
        isVerticalCheckBox: true,
        isVerticalChecked: dashboardData.profitNLoss.isVertical,
        tab_name: 'Profit and Loss',
      };
    }
    if (balanceSheetClicked) {
      return {
        key: 'BalanceSheet',
        opWarningCondition: openingBalance?.BalanceSheet,
        hideZeroLedgerState: hideBSToggleClicked,
        setHideZeroLedgerState: sethideBSToggleClicked,
        hideGroupTotal: hideBSSumToggleClicked,
        setHideGroupTotal: sethideBSSumToggleClicked,
        isVerticalCheckBox: true,
        isVerticalChecked: dashboardData.balanceSheet.isVertical,
        tab_name: 'Balance Sheet',
      };
    }
    if (receivableClicked) {
      return {
        key: 'Receivables',
        opWarningCondition: openingBalance?.Receivables,
        hideZeroLedgerState: hideRecToggleClicked,
        setHideZeroLedgerState: sethideRecToggleClicked,
        hideGroupTotal: hideRecSumToggleClicked,
        setHideGroupTotal: sethideRecSumToggleClicked,
        isVerticalCheckBox: false,
        tab_name: 'Receivables',
      };
    }
    if (payableClicked) {
      return {
        key: 'Payables',
        opWarningCondition: openingBalance?.Payables,
        hideZeroLedgerState: hidePayToggleClicked,
        setHideZeroLedgerState: sethidePayToggleClicked,
        hideGroupTotal: hidePaySumToggleClicked,
        setHideGroupTotal: sethidePaySumToggleClicked,
        isVerticalCheckBox: false,
        tab_name: 'Payables',
      };
    }
    if (trailBalanceClicked) {
      return {
        key: 'TrialBalance',
        opWarningCondition: openingBalance?.TrialBalance,
        hideZeroLedgerState: hideToggleClicked,
        setHideZeroLedgerState: sethideToggleClicked,
        hideGroupTotal: hideSumToggleClicked,
        setHideGroupTotal: sethideSumToggleClicked,
        isVerticalCheckBox: false,
        tab_name: 'Trial Balance',
      };
    }
    if (itemsClicked) {
      return {
        key: 'Items',
        hideZeroLedgerState: hideItemToggleClicked,
        setHideZeroLedgerState: sethideItemToggleClicked,
        hideGroupTotal: hideItemSumToggleClicked,
        setHideGroupTotal: sethideItemSumToggleClicked,
        isVerticalCheckBox: false,
        tab_name: 'Items',
      };
    }
  }, [
    profitnLossClicked,
    balanceSheetClicked,
    receivableClicked,
    payableClicked,
    trailBalanceClicked,
    itemsClicked,
    openingBalance,
    hidePandLToggleClicked,
    hideBSToggleClicked,
    hideRecToggleClicked,
    hidePayToggleClicked,
    hideToggleClicked,
    hideItemToggleClicked,
    hidePandLSumToggleClicked,
    hideBSSumToggleClicked,
    hideRecSumToggleClicked,
    hidePaySumToggleClicked,
    hideSumToggleClicked,
    hideItemSumToggleClicked,
    dashboardData.profitNLoss.isVertical,
    dashboardData.balanceSheet.isVertical,
    displayOpeningBalance,
  ]);

  useEffect(() => {
    dispatch(setNavigationBlocked(false));
  }, []);

  // const isLoading = false
  useEffect(() => {
    const controlAndS = (e) => {
      const id = document.getElementById('companySetup');
      const modal = localStorage.getItem('modalOpen'); // 👈 Read it fresh every time

      if (e.ctrlKey && e.key.toLowerCase() === 's' && modal === null && !id) {
        e.preventDefault();
        // showErrorSnackbar("Nothing to save");
      }
    };

    window.addEventListener('keydown', controlAndS);

    return () => {
      window.removeEventListener('keydown', controlAndS);
    };
  }, []);

  useEffect(() => {
    if (dashboardApiData?.length > 0) {
      setDashboardData(dashboardApiData);
    }
  }, [dashboardApiData]);

  useEffect(() => {
    switch (active) {
      case 'ProfitAndLoss':
        setBusinessOverviewCkicked(false);
        setProfitnLossClicked(true);
        setBalanceSheetCkicked(false);
        setReceivableClicked(false);
        setPayableClicked(false);
        setTrailBalanceClicked(false);
        setItemsClicked(false);
        break;
      case 'BalanceSheet':
        setBusinessOverviewCkicked(false);
        setProfitnLossClicked(false);
        setBalanceSheetCkicked(true);
        setReceivableClicked(false);
        setPayableClicked(false);
        setTrailBalanceClicked(false);
        setItemsClicked(false);
        break;
      case 'Receivables':
        setBusinessOverviewCkicked(false);
        setProfitnLossClicked(false);
        setBalanceSheetCkicked(false);
        setReceivableClicked(true);
        setPayableClicked(false);
        setTrailBalanceClicked(false);
        setItemsClicked(false);
        break;
      case 'Payables':
        setBusinessOverviewCkicked(false);
        setProfitnLossClicked(false);
        setBalanceSheetCkicked(false);
        setReceivableClicked(false);
        setPayableClicked(true);
        setTrailBalanceClicked(false);
        setItemsClicked(false);
        break;
      case 'TrialBalance':
        setBusinessOverviewCkicked(false);
        setProfitnLossClicked(false);
        setBalanceSheetCkicked(false);
        setReceivableClicked(false);
        setPayableClicked(false);
        setTrailBalanceClicked(true);
        setItemsClicked(false);
        break;
      case 'Items':
        setBusinessOverviewCkicked(false);
        setProfitnLossClicked(false);
        setBalanceSheetCkicked(false);
        setReceivableClicked(false);
        setPayableClicked(false);
        setTrailBalanceClicked(false);
        setItemsClicked(true);
        break;
      default:
        setBusinessOverviewCkicked(true);
        setProfitnLossClicked(false);
        setBalanceSheetCkicked(false);
        setReceivableClicked(false);
        setPayableClicked(false);
        setTrailBalanceClicked(false);
        setItemsClicked(false);
        break;
    }
  }, [active]);

  const filteredData = (cb, tabName) => {
    setAIModal(true);
    setAIModalLoading(true);
    // const tabNam = dashboardata[0]?.accounttypecd  === "PandL" ?
    let dataa = [];

    switch (tabName) {
      case 'Profit and Loss':
        dataa =
          dashboardApiData
            ?.filter((item) => item.balance)
            ?.filter((item) => item.accounttypecd === 'PandL')
            ?.map((item) => ({
              group_name: item.accountname,
              creditamount: item.creditamount,
              debitamount: item.debitamount,
            })) || [];
        break;

      case 'Balance Sheet':
        dataa =
          dashboardApiData
            ?.filter((item) => item.balance)
            ?.filter((item) => item.accounttypecd === 'BS')
            ?.map((item) => ({
              group_name: item.accountname,
              creditamount: item.creditamount,
              debitamount: item.debitamount,
            })) || [];
        break;

      case 'Trial Balance':
        dataa =
          dashboardApiData
            ?.filter((item) => item.balance)
            ?.map((item) => ({
              group_name: item.accountname,
              creditamount: item.creditamount,
              debitamount: item.debitamount,
            })) || [];
        break;

      case 'Receivables':
        dataa =
          dashboardata
            ?.filter((item) => item?.group_path?.includes('/15/'))
            ?.filter((item) => item.balance)
            ?.map((item) => ({
              group_name: item.accountname,
              creditamount: item.creditamount,
              debitamount: item.debitamount,
            })) || [];
        break;

      case 'Payables':
        dataa =
          dashboardata
            ?.filter((item) => item?.group_path?.includes('/7/'))
            ?.filter((item) => item.balance)
            ?.map((item) => ({
              group_name: item.accountname,
              creditamount: item.creditamount,
              debitamount: item.debitamount,
            })) || [];
        break;

      default:
        dataa = [];
        break;
    }
    const optimizedObj = dataa.reduce((acc, { group_name, creditamount, debitamount }) => {
      const key = group_name.toUpperCase().trim();

      if (!acc[key]) {
        acc[key] = { creditamount: 0, debitamount: 0 };
      }

      acc[key].creditamount += creditamount;
      acc[key].debitamount += debitamount;

      return acc;
    }, {});
    const totalCLBL = {
      creditamount: totalClosingStock?.[0]?.total_closing_amount,
      debitamount: 0,
    };
    const total =
      tabName !== 'Receivables' && tabName !== 'Receivables'
        ? {
            ...optimizedObj,
            totalCLBL,
          }
        : optimizedObj;

    cb([total], tabName);
  };

  const filterApiData = async (data, tabName) => {
    const payload = {
      tab_name: tabName,
      data,
    };
    try {
      const res = await axiosInstanceForLambda.post(API_ENDPOINTS.REACT_APP_AIBLINK_URL, payload);
      setAISummary(res.data.markdown_summary);
      setAIModalLoading(false);
    } catch (err) {
      console.log(err);
      showWarningSnackbar('Something went wrong please try again');
      setAIModalLoading(false);
    }
  };
  let getCompany = useSelector((state) => state?.companyReducer?.companyDetails);
  let getCompanyLoaded = useSelector((state) => state?.companyReducer?.Loaded);

  async function getCompanyDetails() {
    try {
      if (getCompany?.relatedcompanyentity?.length == 0 || getCompany?.relatedcompanydetailsnew?.length == 0) {
        dispatch(nonGst());
      } else {
        if (getCompany?.relatedcompanydetailsnew.length > 0) {
          if (getCompany?.relatedcompanyentity?.length <= 0) {
            // dispatch(skipNotSave());
            dispatch(nonGst());
          } else {
            // dispatch(skipSave());

            dispatch(nonGst());
          }
        }
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  useEffect(() => {
    if (getCompanyLoaded) getCompanyDetails();
  }, [getCompanyLoaded]);

  const isMediumScreen = useMediaQuery(theme.breakpoints.down('lg'));

  const getPandLData = async (PandLRows, openingStock) => {
    let rowEx = [];
    let rowIn = [];
    let rowEx2 = [];
    let rowIn2 = [];
    let openingStockValue = openingStock?.balance || 0;

    // Classify rows based on id and category
    PandLRows?.forEach((row) => {
      switch (row.id) {
        case 20:
        case 23:
          if (row.category === 'group') rowEx.push(row);
          break;
        case 18:
        case 22:
          if (row.category === 'group') rowIn.push(row);
          break;
        case 24:
          if (row.category === 'group') rowIn2.push(row);
          break;
        case 25:
        case 'EBITDA':
        case 'EBIT':
        case 'PBT':
          if (row.category === 'profitability' || row.category === 'group') rowEx2.push(row);
          break;
        default:
          break;
      }
    });

    // Calculate totals
    const { total_closing_amount = 0 } = totalClosingStock?.[0] || {};
    const exTotal = getTotal(rowEx) + openingStockValue;
    const inTotal = getTotal(rowIn) + total_closing_amount;
    setClosingStockValue(total_closing_amount);

    let grossProfitOrLoss = inTotal - exTotal;
    let grossPOrLType = grossProfitOrLoss >= 0 ? 'profit' : 'loss';

    setgrossIncomeLoss(exTotal - inTotal);
    setgrossbdExpenseProfit(exTotal - inTotal);
    setgrossExpenseProfit(inTotal - exTotal);
    setgrossbdIncomeLoss(inTotal - exTotal);

    setGrossProfitOrLoss(grossPOrLType);

    let grossbOrType = grossPOrLType === 'profit' ? 'loss' : 'profit';

    setGrossbdProfitOrLoss(grossbOrType);

    // const firstTotal = Math.abs(grossProfitOrLoss) + exTotal;
    const firstTotal = Math.max(inTotal, exTotal);

    // // Update gross profit or loss details
    // findByIdAndUpdate(rowEx, 40, {
    //   balance: exTotal,
    //   category: "label",
    // });

    setTotalTradingExpense(exTotal);

    const ex2Total = getTotal(rowEx2.map((row, index) => (index === 0 ? row : row?.children?.[0] || { balance: 0 })));

    const in2Total = getTotal(rowIn2);

    const expTotal = ex2Total + (grossPOrLType === 'loss' ? Math.abs(grossProfitOrLoss) : 0);
    const incTotal = in2Total + (grossPOrLType === 'profit' ? Math.abs(grossProfitOrLoss) : 0);

    const netProfitOrLoss = incTotal - expTotal;

    // Grand Total

    const isVertical = dashboardData?.profitNLoss?.isVertical;

    let grandTotal;
    if (isVertical || isMediumScreen) {
      grandTotal = Math.max(inTotal + in2Total, exTotal + ex2Total);
    } else {
      grandTotal = Math.max(incTotal, expTotal);
    }

    // Update group balances dynamically
    const updateGroupBalances = (groups, grossType, total) => {
      const balances = { 25: 0, 26: 0, 27: 0, 28: 0 };

      groups.forEach((group) => {
        if (balances[group.id] !== undefined) {
          balances[group.id] = group.balance || 0;
        }
        group?.children?.forEach((child) => {
          if (balances[child.id] !== undefined) {
            balances[child.id] = child.balance || 0;
          }
        });

        if (group.id === 'EBITDA') {
          group.balance = grossType === 'profit' ? inTotal - exTotal - balances[25] : -(exTotal - inTotal + balances[25]);
          if (group.balance < 0) {
            group.name = group.name + ' (Loss)';
          }
        } else if (group.id === 'EBIT') {
          group.balance =
            grossType === 'profit' ? inTotal - exTotal - balances[25] - balances[26] : -(exTotal - inTotal + balances[25] + balances[26]);
          if (group.balance < 0) {
            group.name = group.name + ' (Loss)';
          }
        } else if (group.id === 'PBT') {
          group.balance =
            grossType === 'profit'
              ? inTotal - exTotal - balances[25] - balances[26] - balances[27]
              : -(exTotal - inTotal + balances[25] + balances[26] + balances[27]);
          if (group.balance < 0) {
            group.name = group.name + ' (Loss)';
          }
        }
      });

      return groups;
    };

    const updatedRowEx2 = updateGroupBalances(rowEx2, grossPOrLType, grossProfitOrLoss);

    // Set state with results
    setRowsExpense(rowEx);
    setRowsIncome(rowIn);
    setSecondDataExpense(updatedRowEx2);
    setSecondDataIncome(rowIn2);
    setFirstTotal(firstTotal);
    setpandLTotal(grandTotal);

    // Final profit or loss state
    if (incTotal === 0 && expTotal !== 0) {
      setNetIncomeLoss(Math.abs(netProfitOrLoss));
      setNetExpenseLoss(0);
      setProfitOrLoss('loss');
    } else if (incTotal !== 0 && expTotal !== 0 && expTotal - incTotal < 0) {
      setNetExpenseProfit(netProfitOrLoss);
      setNetIncomeProfit(0);
      setProfitOrLoss('profit');
    } else if (expTotal === 0 && incTotal !== 0) {
      setNetExpenseProfit(netProfitOrLoss);
      setNetIncomeProfit(0);
      setProfitOrLoss('profit');
    } else if (incTotal - expTotal < 0) {
      setNetIncomeLoss(Math.abs(netProfitOrLoss));
      setNetExpenseLoss(0);
      setProfitOrLoss('loss');
    } else {
      setNetIncomeLoss(0);
      setNetExpenseLoss(0);
      setNetExpenseProfit(0);
      setNetIncomeProfit(0);
      setProfitOrLoss('');
    }

    return netProfitOrLoss;
  };

  const getTotal = (rows) => {
    let total = 0;
    rows.map((data) => {
      total += data?.balance;
    });
    return total;
  };

  const PinkSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: alpha(theme.palette.shadow.primary, theme.palette.action.hoverOpacity),
      },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: theme.palette.shadow.primary,
    },
  }));

  dispatch(display());

  useEffect(() => {
    if (openingDiffenerenceLedger) {
      if (openingDiffenerenceLedger.credit > 0) {
        settotalCredit(openingDiffenerenceLedger.credit + totalCredit);
      }
      if (openingDiffenerenceLedger.debit > 0) {
        settotalDebit(openingDiffenerenceLedger.debit + totalDebit);
      }
    }
  }, [openingDiffenerenceLedger, hidePandLToggleClicked, hidePandLSumToggleClicked]);

  const handleOpeningBalance = (property) => {
    setOpeningBalance((prevOpeningBalance) => ({
      ...prevOpeningBalance,
      [property]: !prevOpeningBalance[property],
    }));
  };

  const handleTableLayout = async (event, layoutName) => {
    dispatch(setSwitchVertical({ outerKey: layoutName, value: event.target.checked }));

    const userPreferences = userPrefrenceandFY?.userPreference;
    if (!userPreferences) return;

    const existingPreference = userPreferences.find(({ AttributeTypeCD }) => AttributeTypeCD === layoutName);

    const attributeValue = existingPreference ? (existingPreference.AttributeValue === 1 ? 0 : 1) : 1;
    const operation = existingPreference ? updateUserPreference : createUserPreference;

    const variable = existingPreference ? 'updateUserPreferenceInput' : 'createUserPreferenceInput';

    const input = {
      AttributeTypeCD: layoutName,
      AttributeValue: attributeValue,
      AdditionalValue: '',
    };

    await API.graphql(graphqlOperation(operation, { [`${variable}`]: input }));
  };

  useEffect(() => {
    // Only proceed if both company and user preferences are loaded
    if (isCompanyLoaded && !isUserPreferenceLoading && userPrefrenceandFY.financialYear) {
      if (profitnLossClicked) {
        getPandLDbData();
      }

      if (balanceSheetClicked) {
        getBalanceSheetDbData();
      }

      if (trailBalanceClicked && dashboardData.trailBalance?.searchParameters?.searchText === '') {
        const OpeningBalance = openingBalance.TrailBalance ? 1 : 0;
        getTrailBalanceDbData(OpeningBalance, 'TB');
      }

      if (receivableClicked && dashboardData.trailBalance?.searchParameters?.searchText === '') {
        getParty(15);
      }

      if (payableClicked && dashboardData.trailBalance?.searchParameters?.searchText === '') {
        getParty(7);
      }
    }
  }, [
    profitnLossClicked,
    balanceSheetClicked,
    trailBalanceClicked,
    receivableClicked,
    closingStockValue,
    openingBalance,
    payableClicked,
    userPrefrenceandFY.financialYear,
    dashboardata,
    dashboardData?.profitNLoss?.isVertical,
    groupData,
    isMediumScreen,
    totalClosingStock?.[0]?.total_closing_amount,
    isCompanyLoaded,
    isUserPreferenceLoading,
  ]);

  async function getTrailBalanceDbData(OpeningBalance, type) {
    let preventLedger = [23];

    let preventGroup = [];

    if (companyReducer?.companyDetails?.relatedcompanydetailsnew[0]?.registrationtype === 1) {
      preventGroup.push(31, 32, 33);
    }

    if (companyReducer?.companyDetails?.relatedcompanydetailsnew[0]?.gstcompensationcessflag !== 1) {
      preventLedger.push(6, 7, 8, 9);
    }
    if (companyReducer?.companyDetails?.relatedcompanydetailsnew[0]?.registrationtype !== 3) {
      preventLedger.push(32, 33);
    }
    if (
      companyReducer?.companyDetails?.relatedcompanydetailsnew[0]?.registrationtype === 3 ||
      companyReducer?.companyDetails?.relatedcompanydetailsnew[0]?.registrationtype === 1
    ) {
      preventLedger.push(6, 7, 8, 9, 4, 19, 10, 5, 20, 11);
    }
    if (companyReducer?.companyDetails?.relatedcompanydetailsnew[0]?.registrationtype === 1) {
      preventLedger.push(33, 29);
    }

    if (dashboardata?.length && groupData?.length) {
      let TBRows = constructHierarchicalAccountTree([...dashboardata, ...groupData], preventGroup, [...preventLedger], [], []);
      setOpeningBalanceLedger(TBRows?.openingBalanceDiff);
      const flatedData = flattenTree(TBRows?.updatedAccountTree);
      setTBrowsLiabilities(flatedData);
      settotalCredit(TBRows?.totalCredit);
      settotalDebit(TBRows?.totalDebit);
    }
  }

  async function getBalanceSheetDbData() {
    setBackdropOpen(true);
    try {
      if (!dashboardata?.length || !groupData?.length) return;

      const companyDetails = companyReducer?.companyDetails?.relatedcompanydetailsnew?.[0] || {};
      const { registrationtype, gstcompensationcessflag } = companyDetails;

      // Initialize prevention arrays
      const preventGroup = registrationtype === 1 ? [31, 32, 33] : [];
      const preventLedger = [];

      // Build preventLedger array based on conditions
      if (gstcompensationcessflag !== 1) {
        preventLedger.push(6, 7, 8, 9);
      }

      if (registrationtype !== 3) {
        preventLedger.push(32, 33);
      }

      if (registrationtype === 3 || registrationtype === 1) {
        preventLedger.push(6, 7, 8, 9, 4, 19, 10, 5, 20, 11);
      }

      if (registrationtype === 1) {
        preventLedger.push(33);
      }

      const profitabilityAccounts = [
        {
          category: 'profitability',
          type: 'PandL',
          fullName: 'Earnings Before Interest, Taxes, Depreciation, and Amortization',
          name: 'EBITDA',
          id: 'EBITDA',
          _id: 'EBITDA',
          displayName: 'EBITDA',
          parent: null,
          balance: 0,
          restrictedflag: 1,
        },
        {
          category: 'profitability',
          type: 'PandL',
          groupName: 'InDirect Expense',
          fullName: 'Earnings Before Interest and Taxes',
          name: 'EBIT',
          id: 'EBIT',
          _id: 'EBIT',
          parent: null,
          balance: 0,
          restrictedflag: 1,
        },
        {
          category: 'profitability',
          type: 'PandL',
          groupName: 'InDirect Expense',
          fullName: 'Profit Before Tax',
          name: 'PBT',
          id: 'PBT',
          _id: 'PBT',
          parent: null,
          balance: 0,
          restrictedflag: 1,
        },
      ];

      // Get P&L data
      const pandLRows = constructHierarchicalAccountTree(
        [...dashboardata.filter((obj) => obj.accounttypecd === 'PandL'), ...groupData],
        preventGroup,
        preventLedger,
        profitabilityAccounts,
        totalClosingStock
      );

      const netAmount = await getPandLData(pandLRows?.updatedAccountTree, pandLRows?.openingStock);

      // Construct balance sheet data
      const BSRows = constructHierarchicalAccountTree(
        [...dashboardata.filter((obj) => obj.accounttypecd === 'BS'), ...groupData],
        preventGroup,
        [12, ...preventLedger],
        [
          {
            category: 'ledger',
            type: 'BS',
            groupName: 'Profit & Loss',
            fullName: '',
            name: '(+) Net Profit B/d for the year',
            id: 'p2',
            _id: 'p2',
            parent: '46',
            path: '/1/3/46/p2',
            balancesign: 1,
            balance: netAmount,
            credit: netAmount,
            debit: 0,
            restrictedflag: 1,
          },
        ],
        totalClosingStock
      );

      // Update state with processed data
      settotalCredit(BSRows?.totalCredit || 0);
      settotalDebit(BSRows?.totalDebit || 0);

      const rootRows = BSRows?.updatedAccountTree || [];
      const rootLiabilities = rootRows.find((row) => row.id === 1 && row.type === 'BS')?.children || [];
      const rootAssets = rootRows.find((row) => row.id === 10 && row.type === 'BS')?.children || [];

      const flatedDataRl = flattenTree(rootLiabilities);
      const flatedDataRa = flattenTree(rootAssets);
      setOpeningBalanceLedger(BSRows?.openingBalanceDiff);
      dispatch(setTableRowCount2({ key: 'table1', count: flatedDataRl.length }));
      dispatch(setTableRowCount2({ key: 'table2', count: flatedDataRa.length }));
      setRowsLiabilities(flatedDataRl);
      setRowAssets(flatedDataRa);
    } catch (error) {
      console.error('Error in getBalanceSheetDbData:', error);
    } finally {
      setBackdropOpen(false);
    }
  }
  function updateGroupBalances(data) {
    function processGroup(group) {
      let total = 0;
      let totalDebit = 0;
      let totalCredit = 0;

      if (group.children && group.children.length > 0) {
        group.children.forEach((child) => {
          if (child.category === 'ledger') {
            total += child.relatedData.BalanceAmount;
            totalDebit += child.relatedData.Debit;
            totalCredit += child.relatedData.Credit;
          } else if (child.category === 'group') {
            const childTotals = processGroup(child);
            total += childTotals.total;
            totalDebit += childTotals.totalDebit;
            totalCredit += childTotals.totalCredit;
          }
        });
      }

      if (group.category === 'group' && group.relatedData) {
        group.relatedData.BalanceAmount = total;
        group.relatedData.Debit = totalDebit;
        group.relatedData.Credit = totalCredit;
      }
      return {
        totalDebit: totalDebit,
        totalCredit: totalCredit,
        total: total,
      };
    }

    data.forEach((group) => processGroup(group));
    return data;
  }

  async function getPandLDbData() {
    let pandlRows = [];
    if (dashboardata?.length && groupData?.length) {
      const anotherAccounts = [
        {
          category: 'profitability',
          type: 'PandL',
          groupName: '',
          fullName: 'Earnings Before Interest, Taxes, Depreciation, and Amortization',
          name: 'EBITDA',
          id: 'EBITDA',
          _id: 'EBITDA',
          displayName: 'EBITDA',
          parent: null,
          balance: 0,
          restrictedflag: 1,
        },
        {
          category: 'profitability',
          type: 'PandL',
          groupName: 'InDirect Expense',
          fullName: 'Earnings Before Interest and Taxes',
          name: 'EBIT',
          id: 'EBIT',
          _id: 'EBIT',
          parent: null,
          balance: 0,
          restrictedflag: 1,
        },
        {
          category: 'profitability',
          type: 'PandL',
          groupName: 'InDirect Expense',
          fullName: 'Profit Before Tax',
          id: 'PBT',
          _id: 'PBT',
          parent: null,
          balance: 0,
          restrictedflag: 1,
          name: 'PBT',
        },
      ];
      let preventLedger = [];
      if (companyReducer?.companyDetails?.relatedcompanydetailsnew[0]?.registrationtype !== 3) {
        preventLedger.push(32, 33);
      }

      if (companyReducer?.companyDetails?.relatedcompanydetailsnew[0]?.registrationtype === 1) {
        preventLedger.push(33, 29);
      }
      pandlRows = constructHierarchicalAccountTree([...dashboardata, ...groupData], [], preventLedger, anotherAccounts, totalClosingStock);
    }
    setOpeningStock(pandlRows?.openingStock);
    getPandLData(pandlRows?.updatedAccountTree, pandlRows?.openingStock);
  }

  const getParty = (id) => {
    if (dashboardata?.length && groupData?.length) {
      const filteredGroupData = groupData.filter((obj) => {
        const segments = obj.path.split('/');
        return segments.includes('15') || segments.includes('7');
      });
      let BSRows = constructHierarchicalAccountTree(
        [...dashboardata.filter((obj) => obj.accounttypecd === 'BS'), ...filteredGroupData],
        [],
        [12],
        []
      );
      let recRows = BSRows?.updatedAccountTree.filter((obj) => obj.id === id && obj.category === 'group');
      const flatedData = flattenTree(recRows);
      setreceivables(flatedData);
    }
  };

  const handleItemExpand = () => {
    setExpandItemClicked(!expandItemClicked);
  };

  const getCurrentTab = () => {
    return itemsClicked ? 'item' : 'dashboard';
  };

  useEffect(() => {
    if (profitnLossClicked || balanceSheetClicked || receivableClicked || payableClicked || trailBalanceClicked) {
      setSearchFilterPayables('all');
      setSearchFilterPayables('all');
      setSearchFilterTrialBalance('all');
    }
  }, [profitnLossClicked, balanceSheetClicked, receivableClicked, payableClicked, trailBalanceClicked]);

  const [anchorElPL, setAnchorElPL] = useState(null);

  const openMenuPL = (event) => {
    setAnchorElPL(event.currentTarget);
  };

  const closeMenuPL = () => {
    setAnchorElPL(null);
  };

  const open = Boolean(anchorElPL);
  const id = open ? 'simple-popover' : undefined;

  // Export modal handlers
  const handleExportClick = () => {
    setExportModalOpen(true);
  };

  const handleExportModalClose = () => {
    setExportModalOpen(false);
    setExportLoading(false);
  };

  const handleExport = async (exportData) => {
    setExportLoading(true);
    try {
      const requestData = {
        page: 'Dashboard',
        type:
          tabKey?.tab_name === 'Profit and Loss'
            ? 'Profit&Loss'
            : tabKey?.tab_name === 'Balance Sheet'
            ? 'BalanceSheet'
            : tabKey?.tab_name === 'Trial Balance'
            ? 'TrailBalance'
            : tabKey?.tab_name || 'Dashboard',
        fromDate: exportData.startDate,
        toDate: exportData.endDate,
        includeOpeningBalance: tabKey?.opWarningCondition ? 1 : 0,
        hideZeroBalance: tabKey?.hideZeroLedgerState,
        hideGroupTotal: tabKey?.hideGroupTotal,
        format: exportData.format,
        financialYearId: userPrefrenceandFY?.financialYear?.financialyearid,
      };

      const response = await axiosInstanceForLambda({
        method: 'POST',
        url: API_ENDPOINTS.REACT_APP_EXPORT_URL,
        data: requestData,
      });

      if (response.status === 200) {
        const buffer = Buffer.from(response?.data);
        const blob = new Blob([buffer]);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `ledgerX_Export_${exportData.tabName?.replace(/\s+/g, '_')}_${exportData.startDate}.${exportData.format}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setExportModalOpen(false);
      } else {
        showErrorSnackbar('Failed to export. Please try again.');
      }
    } catch (error) {
      console.error('Export Error:', error);
      showErrorSnackbar('Internal server error. Please try again later.');
    } finally {
      setExportLoading(false);
    }
  };

  return (
    <Box
      sx={{
        // height: "90dvh",
        overflow: 'auto',
        // height: window.innerHeight,
        '::-webkit-scrollbar': {
          width: 10,
        },
        '::-webkit-scrollbar-track': {
          background: '#f1f1f1',
        },
        '::-webkit-scrollbar-thumb': {
          background: '#888',
        },
      }}
    >
      <Box>
        <Menubar
          setProfitnLossClicked={setProfitnLossClicked}
          profitnLossClicked={profitnLossClicked}
          businessOverviewCkicked={businessOverviewCkicked}
          setBusinessOverviewCkicked={setBusinessOverviewCkicked}
          balanceSheetClicked={balanceSheetClicked}
          setBalanceSheetCkicked={setBalanceSheetCkicked}
          receivableClicked={receivableClicked}
          setReceivableClicked={setReceivableClicked}
          payableClicked={payableClicked}
          setPayableClicked={setPayableClicked}
          trailBalanceClicked={trailBalanceClicked}
          setTrailBalanceClicked={setTrailBalanceClicked}
          itemsClicked={itemsClicked}
          setItemsClicked={setItemsClicked}
          isFinancialYearAvailable={isFinancialYearAvailable}
        />
        {businessOverviewCkicked && (
          <>
            <BusinessOverview startDate={dashboardData.startDate} endDate={dashboardData.endDate} />
          </>
        )}
        <Box
          sx={{
            display: businessOverviewCkicked ? 'none' : 'block',
          }}
        >
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              justifyContent: { xs: 'center', md: 'space-between' },
              flexWrap: { md: 'wrap' },
              px: { xs: 2, md: 2 },
              gap: 1,
            }}
          >
            <Box sx={{}}>
              <ActionItems
                title={profitnLossClicked || itemsClicked ? 'Period' : dashboardData?.bsPeriod?.range === 'date' ? 'Period' : 'As on'}
                anchorEl={anchorEl}
                setAnchorEl={setAnchorEl}
                page={
                  profitnLossClicked
                    ? 'pandlPeriod'
                    : itemsClicked
                    ? 'pandlPeriod'
                    : balanceSheetClicked || trailBalanceClicked || receivableClicked || payableClicked
                    ? 'bsPeriod'
                    : ''
                }
                openingBalanceRequired={
                  profitnLossClicked || balanceSheetClicked || trailBalanceClicked || receivableClicked || payableClicked
                }
                isCustomDateModalOpen={isCustomDateModalOpen}
                setIsCustomDateModalOpen={setIsCustomDateModalOpen}
                showDateRangeText={false}
                setDateRangeText={setDateRangeText}
                includeOpeningBalance={tabKey?.opWarningCondition}
                setIncludeOpeningBalance={(value) => handleOpeningBalance(tabKey?.key)}
              />
            </Box>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Popover
                id={id}
                open={open}
                anchorEl={anchorElPL}
                onClose={closeMenuPL}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
              >
                <Box
                  sx={{
                    p: '6px',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <FormControlLabel
                    value="Left"
                    control={
                      <Checkbox checked={tabKey?.hideZeroLedgerState} onChange={(e) => tabKey?.setHideZeroLedgerState(e.target.checked)} />
                    }
                    label={itemsClicked ? 'Hide Items With Zero Stock Amount' : 'Hide Ledgers With Zero Balance'}
                    labelPlacement="end"
                    sx={{
                      '.MuiTypography-root': {
                        fontSize: '14px',
                      },
                      color: 'shadow.primary',
                    }}
                  />

                  <FormControlLabel
                    value="Right"
                    control={<Checkbox checked={tabKey?.hideGroupTotal} onChange={(e) => tabKey?.setHideGroupTotal(e.target.checked)} />}
                    label={itemsClicked ? 'Hide Category Totals' : 'Hide Group Totals'}
                    labelPlacement="end"
                    sx={{
                      '.MuiTypography-root': {
                        fontSize: '14px',
                      },
                      color: 'shadow.primary',
                    }}
                  />

                  {/* <FormControlLabel
                    id="switch"
                    value="Right"
                    control={
                      <Checkbox
                        checked={tabKey?.onlyOpeningBalance}
                        onChange={() =>
                          setDisplayOpeningBalance((prev) => {
                            return {
                              ...prev,
                              [tabKey?.key]: !tabKey?.onlyOpeningBalance,
                            };
                          })
                        }
                      />
                    }
                    label="Display Only Opening Balance"
                    labelPlacement="end"
                    sx={{
                      '.MuiTypography-root': {
                        fontSize: '14px',
                      },
                      color: 'shadow.primary',
                    }}
                  /> */}

                  {tabKey?.isVerticalCheckBox && !matches && (
                    <FormControlLabel
                      value="Right"
                      control={
                        <Checkbox
                          checked={tabKey?.isVerticalChecked}
                          onChange={(event) => {
                            handleTableLayout(event, profitnLossClicked ? 'profitNLoss' : 'balanceSheet');
                          }}
                        />
                      }
                      label="Switch to Vertical"
                      labelPlacement="end"
                      sx={{
                        '.MuiTypography-root': {
                          fontSize: '14px',
                        },
                        color: 'shadow.primary',
                      }}
                    />
                  )}
                </Box>
              </Popover>
            </Box>
            <Box
              className="DbTools"
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: { xs: 'space-between', md: 'end' },
                flexWrap: 'wrap',
                position: 'sticky',
                top: 80,
                zIndex: 1,
                m: { xs: 0, sm: 1 },
                gap: '5px',
              }}
            >
              <Box
                sx={{
                  order: { xs: 6, sm: 1 },
                  // display: { xs: 'none', sm: 'block' },
                }}
              >
                {itemsClicked === false && (
                  <AIBlinkButton sx={{ marginTop: '0px' }} onClick={() => filteredData(filterApiData, tabKey?.tab_name)} />
                )}
              </Box>

              <Box sx={{ order: { xs: 1, sm: 2 }, display: { xs: 'none', sm: 'block' } }}>
                <Tooltip title="Print" arrow>
                  <Button
                    disableRipple
                    disableElevation
                    variant="outlined"
                    sx={{
                      color: theme?.palette?.TmId.id.toString().includes('9') ? '' : 'primary.main',
                      backgroundColor: 'bodyGray.main',
                      fontSize: '10px',
                      border: '1px solid',
                      borderColor: 'bodyGray.main',
                      boxShadow: `
                            inset 0 0 0.5px 1px hsla(0, 0%, 100%, 0.075),
                            0 0 0 1px hsla(0, 0%, 0%, 0.05),
                            0 0.3px 0.4px hsla(0, 0%, 0%, 0.02),
                            0 0.9px 1.5px hsla(0, 0%, 0%, 0.045),
                            0 3.5px 6px hsla(0, 0%, 0%, 0.09)
                          `,
                      height: '30px',
                      minWidth: { xs: '50px', sm: '64px' },
                    }}
                    onClick={() => {
                      if (profitnLossClicked) {
                        generateDashboardPrintableTable(
                          {
                            expenseFirstPart: rowsExpense,
                            expenseSecondPart: secondDataExpense,
                            incomeFirstPart: rowsIncome,
                            incomeSecondPart: secondDataIncome,
                            closingStockValue,
                            openingStock,
                            firstTotal,
                            pandLTotal,
                            grossprotitOrLoss,
                            grossExpenseProfit,
                            grossbdIncomeloss,
                            grossbdExpenseProfit,
                            grossIncomeloss,
                            protitOrLoss,
                            netIncomeloss,
                            netExpenseProfit,
                          },
                          [
                            { key: 'name', label: 'Account' },
                            {
                              key: 'amount',
                              label: 'Amount',
                              align: 'right',
                            },
                          ],
                          'Profit and Loss',
                          'pandl',
                          companyReducer.companyName,
                          companyReducer.companyDetails,
                          dashboardVariables.current,
                          {
                            hideGroupTotal: hidePandLSumToggleClicked,
                            hideZeroBalLedger: hidePandLToggleClicked,
                          }
                        );
                      }

                      if (balanceSheetClicked) {
                        generateDashboardPrintableTable(
                          {
                            liabilities: rowsLiabilities,
                            assets: rowsAssets,
                            openingBalanceDiff: openingDiffenerenceLedger,
                          },
                          [
                            { key: 'name', label: 'Account' },
                            {
                              key: 'amount',
                              label: 'Amount',
                              align: 'right',
                            },
                          ],
                          'BalanceSheet',
                          'balancesheet',
                          companyReducer.companyName,
                          companyReducer.companyDetails,
                          dashboardVariables.current,
                          {
                            hideGroupTotal: hideBSSumToggleClicked,
                            hideZeroBalLedger: hideBSToggleClicked,
                          }
                        );
                      }

                      if (receivableClicked) {
                        generateDashboardPrintableTable(
                          {
                            rows: receivables,
                          },
                          [
                            { key: 'name', label: 'Account' },
                            {
                              key: 'amount',
                              label: 'Amount',
                              align: 'right',
                            },
                          ],
                          'Receivables',
                          'Receivables',
                          companyReducer.companyName,
                          companyReducer.companyDetails,
                          dashboardVariables.current,
                          {
                            hideGroupTotal: hideRecSumToggleClicked,
                            hideZeroBalLedger: hideRecToggleClicked,
                          }
                        );
                      }
                      if (payableClicked) {
                        generateDashboardPrintableTable(
                          {
                            rows: receivables,
                          },
                          [
                            { key: 'name', label: 'Account' },
                            {
                              key: 'amount',
                              label: 'Amount',
                              align: 'right',
                            },
                          ],
                          'Payables',
                          'Payables',
                          companyReducer.companyName,
                          companyReducer.companyDetails,
                          dashboardVariables.current,
                          {
                            hideGroupTotal: hidePaySumToggleClicked,
                            hideZeroBalLedger: hidePandLToggleClicked,
                          }
                        );
                      }
                      if (trailBalanceClicked) {
                        generateDashboardPrintableTable(
                          {
                            rows: TBrowsLiabilities,
                            openingBalanceDiff: openingDiffenerenceLedger,
                          },
                          [
                            { key: 'name', label: 'Account' },
                            {
                              key: 'amount',
                              label: 'Amount',
                              align: 'right',
                            },
                          ],
                          'TrialBalance',
                          'TrialBalance',
                          companyReducer.companyName,
                          companyReducer.companyDetails,
                          dashboardVariables.current,
                          {
                            hideGroupTotal: hideSumToggleClicked,
                            hideZeroBalLedger: hideToggleClicked,
                          }
                        );
                      }
                      if (itemsClicked) {
                        generateDashboardPrintableTable(
                          {
                            rows: itemRow,
                          },
                          [
                            { key: 'name', label: 'Item' },
                            { key: 'qty', label: 'No of units in hand' },
                            { key: 'price', label: 'Total value' },
                          ],
                          'Items',
                          'Item',
                          companyReducer.companyName,
                          companyReducer.companyDetails,
                          dashboardVariables.current,
                          {
                            hideGroupTotal: hideItemSumToggleClicked,
                            hideZeroBalLedger: hideItemToggleClicked,
                          }
                        );
                      }
                    }}
                  >
                    {<LocalPrintshop />}
                  </Button>
                </Tooltip>
              </Box>

              <Box sx={{ order: { xs: 2, sm: 3 } }}>
                <DbExportButton
                  dbItem={
                    profitnLossClicked
                      ? 'Profit&Loss'
                      : balanceSheetClicked
                      ? 'BalanceSheet'
                      : receivableClicked
                      ? 'Receivables'
                      : payableClicked
                      ? 'Payables'
                      : trailBalanceClicked
                      ? 'TrailBalance'
                      : itemsClicked
                      ? 'Items'
                      : ''
                  }
                  dashboardVariables={dashboardVariables.current}
                  company={companyReducer}
                  financialyearid={userPrefrenceandFY?.financialYear?.financialyearid}
                  hideZeroBalance={tabKey?.hideZeroLedgerState}
                  hideGroupTotal={tabKey?.hideGroupTotal}
                  onExportClick={handleExportClick}
                />
              </Box>

              <Box sx={{ order: { xs: 3, sm: 4 } }}>
                <Tooltip title="Expand/Collapse" arrow>
                  <Button
                    disableRipple
                    disableElevation
                    variant="outlined"
                    sx={{
                      color: expandPandLClicked ? '#EDEDED' : 'primary.main',
                      backgroundColor: expandPandLClicked ? 'primary.main' : 'bodyGray.main',
                      fontSize: '12px',
                      border: '1px solid',
                      borderColor: 'bodyGray.main',
                      boxShadow: `
                        inset 0 0 0.5px 1px hsla(0, 0%, 100%, 0.075),
                        0 0 0 1px hsla(0, 0%, 0%, 0.05),
                        0 0.3px 0.4px hsla(0, 0%, 0%, 0.02),
                        0 0.9px 1.5px hsla(0, 0%, 0%, 0.045),
                        0 3.5px 6px hsla(0, 0%, 0%, 0.09)
                      `,

                      height: '30px',
                      // height: "30px",
                      minWidth: { xs: '50px', sm: '64px' },
                      ':hover': {
                        color: 'black',
                      },
                    }}
                    onClick={() =>
                      profitnLossClicked
                        ? setExpandPandLClicked(!expandPandLClicked)
                        : balanceSheetClicked
                        ? setExpandBSClicked(!expandBSClicked)
                        : receivableClicked
                        ? setExpandRecClicked(!expandRecClicked)
                        : payableClicked
                        ? setExpandPayClicked(!expandPayClicked)
                        : trailBalanceClicked
                        ? setExpandTBClicked(!expandTBClicked)
                        : itemsClicked
                        ? setExpandItemClicked(!expandItemClicked)
                        : ''
                    }
                  >
                    {(
                      profitnLossClicked
                        ? expandPandLClicked
                        : balanceSheetClicked
                        ? expandBSClicked
                        : receivableClicked
                        ? expandRecClicked
                        : payableClicked
                        ? expandPayClicked
                        : trailBalanceClicked
                        ? expandTBClicked
                        : itemsClicked
                        ? expandItemClicked
                        : false
                    ) ? (
                      <CloseFullscreen />
                    ) : (
                      <OpenInFull />
                    )}
                  </Button>
                </Tooltip>
              </Box>

              <Box sx={{ order: { xs: 4, sm: 5 } }}>
                <DbReloadBtn tab={getCurrentTab()} />
              </Box>

              <Button
                sx={{
                  height: '30px',
                  minWidth: 'unset',
                  width: { xs: '50px', sm: '64px' },
                  order: { xs: 5, sm: 6 },
                }}
                variant="contained"
                onClick={openMenuPL}
              >
                <MoreVert />
              </Button>
            </Box>
          </Box>{' '}
        </Box>

        {profitnLossClicked && (
          <>
            <Box
              id="ProfitNLossComponent"
              sx={{
                borderRadius: 2,
                background: 'transparent',
                position: 'relative',
                boxShadow: 'none',
                overflow: 'hidden',
                ':not(:root):fullscreen': {
                  overflow: 'hidden',
                },
                paddingBottom: '20px',
              }}
            >
              <Grid
                container
                justify="flex-start"
                columnSpacing={!dashboardData.profitNLoss.isVertical && !isMediumScreen ? { md: 0, lg: 1 } : 0}
                rowSpacing={1}
              >
                <Grid
                  item
                  xs={12}
                  md={12}
                  lg={dashboardData.profitNLoss.isVertical ? 12 : 6}
                  order={{
                    xs: 2,
                    lg: dashboardData.profitNLoss.isVertical ? 3 : 1,
                  }}
                >
                  <Box
                    sx={{
                      width: '100%',
                      height: '100%',
                      overflow: 'auto',
                    }}
                  >
                    <ProfitNLossTableNew
                      heading={'Expense'}
                      section={1}
                      rows={rowsExpense}
                      hidePandLToggleClicked={hidePandLToggleClicked}
                      totalTradingExpense={totalTradingExpense}
                      rows2={secondDataExpense}
                      selectedParentId={selectedParentId}
                      headColor={`${theme.palette.primary.main}`}
                      cellMaxWidht={rowsMaxWidth}
                      openingStock={openingStock}
                      shadowColor={theme.palette.shadow.primary}
                      expandButtonClicked={expandPandLClicked}
                      firstTotal={firstTotal}
                      mainTotal={pandLTotal}
                      netLoss={netExpenseloss}
                      netProfit={netExpenseProfit}
                      profitorLoss={protitOrLoss}
                      grossProfitorLoss={grossprotitOrLoss}
                      grossLoss={grossExpenseloss}
                      grossProfit={grossExpenseProfit}
                      grossbdProfitorLoss={grossbdprotitOrLoss}
                      grossbdLoss={grossbdExpenseloss}
                      grossbdProfit={grossbdExpenseProfit}
                      hideAmount={hidePandLSumToggleClicked}
                      setAccountID={setAccountID}
                      setNewLedgerResponse={setNewLedgerResponse}
                      newLedgerAccountID={newLedgerResponse}
                      headGroupsIncome={headGroupsIncome}
                      headGroupsExpense={headGroupsExpense}
                      setgroups={setgroups}
                      setHEadGroupsIncome={setHEadGroupsIncome}
                      setHEadGroupsExpense={setHEadGroupsExpense}
                      asOnDate={closingstockdate}
                      setSelectedParentId={setSelectedParentId}
                      refetchDb={refetchDashboard}
                      startTimeStamp={dbStartDate}
                      endTimeStamp={dbEndDate}
                    />
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={12}
                  lg={dashboardData.profitNLoss.isVertical ? 12 : 6}
                  order={{
                    xs: 1,
                    lg: dashboardData.profitNLoss.isVertical ? 1 : 2,
                  }}
                >
                  <Box
                    sx={{
                      width: '100%',
                      height: '100%',
                      overflow: 'auto',
                    }}
                  >
                    <ProfitNLossTableNew
                      heading={'Income'}
                      section={1}
                      rows={rowsIncome}
                      rows2={secondDataIncome}
                      hidePandLToggleClicked={hidePandLToggleClicked}
                      netLoss={netIncomeloss}
                      netProfit={netIncomeProfit}
                      selectedParentId={selectedParentId}
                      headColor={`${theme.palette.secondary.main}`}
                      cellMaxWidht={rowsMaxWidth}
                      shadowColor={theme.palette.shadow.secondary}
                      expandButtonClicked={expandPandLClicked}
                      firstTotal={firstTotal}
                      mainTotal={pandLTotal}
                      profitorLoss={protitOrLoss}
                      grossProfitorLoss={grossprotitOrLoss}
                      grossLoss={grossIncomeloss}
                      grossProfit={grossIncomeProfit}
                      grossbdProfitorLoss={grossbdprotitOrLoss}
                      grossbdLoss={grossbdIncomeloss}
                      grossbdProfit={grossbdIncomeProfit}
                      hideAmount={hidePandLSumToggleClicked}
                      setAccountID={setAccountID}
                      setNewLedgerResponse={setNewLedgerResponse}
                      newLedgerAccountID={newLedgerResponse}
                      closingStockValue={closingStockValue}
                      setClosingStockValue={setClosingStockValue}
                      headGroupsIncome={headGroupsIncome}
                      headGroupsExpense={headGroupsExpense}
                      setgroups={setgroups}
                      setHEadGroupsIncome={setHEadGroupsIncome}
                      setHEadGroupsExpense={setHEadGroupsExpense}
                      asOnDate={closingstockdate}
                      setSelectedParentId={setSelectedParentId}
                      refetchDb={refetchDashboard}
                      startTimeStamp={dbStartDate}
                      endTimeStamp={dbEndDate}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </>
        )}
        {balanceSheetClicked && (
          <Box
            sx={{
              borderRadius: 4,
              padding: { xs: '2px', sm: '8px' },
              paddingLeft: 1,
              boxShadow: 'none',
              background: 'transparent',
              width: { xs: '100%' },
              overflow: 'scroll',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: {
                  xs: 'column-reverse',
                  md: dashboardData.balanceSheet.isVertical ? 'column-reverse' : 'row',
                },
                justifyContent: { xs: 'center', md: 'space-between' },
                gap: 1,
              }}
            >
              {/* Liabilities Table */}
              <Box
                style={{
                  flex: 1,
                  padding: { xs: 1, md: 2, lg: 5 },
                  borderRadius: 6,
                }}
              >
                <BalanceSheetTableNew
                  key={'balanceSheetTable1'}
                  heading={'Liabilities'}
                  rows={rowsLiabilities}
                  hideBSToggleClicked={hideBSToggleClicked}
                  setSelectedParentId={setSelectedParentId}
                  selectedParentId={selectedParentId}
                  mainTotal={totalCredit}
                  openingBalanceDiff={openingDiffenerenceLedger}
                  headColor={'primary.main'}
                  shadowColor={theme.palette.shadow.primary}
                  expandButtonClicked={expandBSClicked}
                  BSGroups={BsGroups}
                  hideAmount={hideBSSumToggleClicked}
                  setAccountID={setAccountID}
                  setBackdropOpen={() => {}}
                  setNewLedgerResponse={setNewLedgerResponse}
                  newLedgerAccountID={newLedgerResponse}
                  cellMaxWidht={rowsMaxWidth}
                  refetchDb={refetchDashboard}
                  tableRowDiff={tableRowDiff.tableOne}
                  row
                  startTimeStamp={dbStartDate}
                  endTimeStamp={dbEndDate}
                />
              </Box>

              {/* Assets Table */}
              <Box
                style={{
                  flex: 1,
                  padding: { xs: 1, md: 2, lg: 5 },
                  borderRadius: 6,
                }}
              >
                <BalanceSheetTableNew
                  key={'balanceSheetTable2'}
                  heading={'Assets'}
                  rows={rowsAssets}
                  headColor={'secondary.main'}
                  setSelectedParentId={setSelectedParentId}
                  hideBSToggleClicked={hideBSToggleClicked}
                  selectedParentId={selectedParentId}
                  openingBalanceDiff={openingDiffenerenceLedger}
                  expandButtonClicked={expandBSClicked}
                  hideAmount={hideBSSumToggleClicked}
                  mainTotal={totalDebit}
                  setAccountID={setAccountID}
                  setBackdropOpen={() => {}}
                  setNewLedgerResponse={setNewLedgerResponse}
                  newLedgerAccountID={newLedgerResponse}
                  setClosingStockValue={setClosingStockValue}
                  asOnDate={closingstockdate}
                  refetchDb={refetchDashboard}
                  tableRowDiff={tableRowDiff.tableTwo}
                  startTimeStamp={dbStartDate}
                  endTimeStamp={dbEndDate}
                />
              </Box>
            </Box>

            {/* <Grid
              container
              gap={3}
              sx={{ display: "flex", alignItems: "stretch", mt: 2 }}
            >
              <Grid
                item
                xs={12}
                lg={dashboardData.balanceSheet.isVertical ? 12 : 5.9}
                flex={1}
                order={{
                  sm: 2,
                  lg: dashboardData.balanceSheet.isVertical ? 2 : 1,
                }}
              >
              
              </Grid>
              <Grid
                item
                xs={12}
                lg={dashboardData.balanceSheet.isVertical ? 12 : 5.8}
                flex={1}
                order={{
                  sm: 1,
                  lg: dashboardData.balanceSheet.isVertical ? 1 : 2,
                }}
              >
              
              </Grid>
            </Grid> */}
          </Box>
        )}
        {receivableClicked && (
          <Box
            sx={{
              borderRadius: 4,
              p: { sm: 1, xs: '4px 0' },
              // boxShadow: `
              // inset 0 0 0.5px 1px hsla(0, 0%, 100%, 0.075),
              // 0 0 0 1px hsla(0, 0%, 0%, 0.05),
              // 0 0.3px 0.4px hsla(0, 0%, 0%, 0.02),
              // 0 0.9px 1.5px hsla(0, 0%, 0%, 0.045),
              // 0 3.5px 6px hsla(0, 0%, 0%, 0.09)`,
            }}
          >
            {/* <Box
              sx={{
                alignItems: "center",
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                justifyContent: { xs: "center", md: "space-between" },
                flexWrap: { md: "wrap" },
                gap: 1,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: { xs: "column", sm: "row" },
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <DashboardPeriodSelector
                    page="dateRange"
                    title="Period"
                  />
                  <Box sx={{ display: { xs: "block", sm: "none" } }}>
                    <AIBlinkButton
                      sx={{ marginTop: "0px" }}
                      onClick={async () => {
                        setAIModal(true);
                        setAIModalLoading(true);
                        const payload = {
                          tab_name: "profit and Loss",
                          data: aiPLData,
                        };
                        try {
                          const res = await axiosInstanceForLambda.post(
                            API_ENDPOINTS.REACT_APP_AIBLINK_URL,
                            payload
                          );
                          setAISummary(res.data.markdown_summary);
                          setAIModalLoading(false);
                          console.log(res, "res");
                        } catch (err) {
                          console.log(err, "err");
                          if (err) {
                            showWarningSnackbar(
                              "Something went wrong please try again"
                            );
                            setAIModalLoading(false);
                          }
                        }
                      }}
                    />
                  </Box>
                </Box>
                {!openingBalance?.ProfitAndLoss &&
                  DashboardOpWarning({ title: "profit & loss" })}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  marginRight: { xs: 0, md: 4 },
                }}
              >
                <Popover
                  id={id}
                  open={open}
                  anchorEl={anchorElPL}
                  onClose={closeMenuPL}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                >
                  <Box
                    sx={{ p: "5px", display: "flex", flexDirection: "column" }}
                  >
                    <FormControlLabel
                      value="Left"
                      control={
                        <Checkbox
                          checked={hideRecToggleClicked}
                          onChange={(e) => {
                            sethideRecToggleClicked(e.target.checked);
                          }}
                        />
                      }
                      label="Hide Ledgers With Zero Balance"
                      labelPlacement="end"
                      sx={{
                        ".MuiTypography-root": {
                          fontSize: "14px",
                        },
                        color: "shadow.primary",
                      }}
                    />
                    <FormControlLabel
                      value="Left"
                      control={
                        <Checkbox
                          checked={hideRecSumToggleClicked}
                          onChange={(e) => {
                            sethideRecSumToggleClicked(e.target.checked);
                          }}
                        />
                      }
                      label="Hide Group Totals"
                      labelPlacement="end"
                      sx={{
                        ".MuiTypography-root": {
                          fontSize: "14px",
                        },
                        color: "shadow.primary",
                      }}
                    />
                    <FormControlLabel
                      id="switch"
                      value="Left"
                      control={
                        <Checkbox
                          checked={openingBalance.trailBalance}
                          onChange={() => {
                            handleOpeningBalance("trailBalance");
                          }}
                        />
                      }
                      label="Include Opening balance"
                      labelPlacement="end"
                      sx={{
                        ".MuiTypography-root": {
                          fontSize: "14px",
                        },
                        color: "shadow.primary",
                      }}
                    />
                  </Box>
                </Popover>
              </Box>
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  flexDirection: "row",
                  justifyContent: { xs: "center", md: "end" },
                  flexWrap: "wrap",
                  position: "sticky",
                  top: 80,
                  zIndex: 1,
                  gap: "5px",
                  pr: { xs: "0px", sm: "20px" },
                  m: { xs: 0, sm: 1 },
                  marginBottom: 1,
                }}
              >
                <Box sx={{ display: { xs: "none", sm: "block" } }}>
                  <AIBlinkButton
                    sx={{ marginTop: "-18px" }}
                    onClick={async () => {
                      setAIModal(true);
                      setAIModalLoading(true);
                      const payload = {
                        tab_name: "Receivables",
                        data: aiRData,
                      };
                      try {
                        const res = await axiosInstanceForLambda.post(
                          API_ENDPOINTS.REACT_APP_AIBLINK_URL,
                          payload
                        );
                        setAISummary(res.data.markdown_summary);
                        setAIModalLoading(false);
                        console.log(res, "res");
                      } catch (err) {
                        console.log(err, "err");
                        if (err) {
                          showWarningSnackbar(
                            "Something went wrong please try again"
                          );
                          setAIModalLoading(false);
                        }
                      }
                    }}
                  />
                </Box>

                <Tooltip title="Print" arrow>
                  <Button
                    disableRipple
                    disableElevation
                    variant="outlined"
                    sx={{
                      color: "primary.main",
                      backgroundColor: "bodyGray.main",
                      fontSize: "12px",
                      border: "1px solid",
                      borderColor: "bodyGray.main",
                      height: "30px",
                      boxShadow: `
    inset 0 0 0.5px 1px hsla(0, 0%, 100%, 0.075),
    0 0 0 1px hsla(0, 0%, 0%, 0.05),
    0 0.3px 0.4px hsla(0, 0%, 0%, 0.02),
    0 0.9px 1.5px hsla(0, 0%, 0%, 0.045),
    0 3.5px 6px hsla(0, 0%, 0%, 0.09)`,
                      minWidth: { xs: "50px", sm: "64px" },
                    }}
                    onClick={() =>
                      generateDashboardPrintableTable(
                        {
                          rows: receivables,
                        },
                        [
                          { key: "name", label: "Account" },
                          { key: "amount", label: "Amount", align: "right" },
                        ],
                        "Receivables",
                        "Receivable",
                        companyReducer.companyName,
                        dashboardVariables,
                        {
                          hideGroupTotal: hideRecSumToggleClicked,
                          hideZeroBalLedger: hideRecToggleClicked,
                        }
                      )
                    }
                  >
                    {<LocalPrintshop />}
                  </Button>
                </Tooltip>
                <DbExportButton
                  dbItem="Receivables"
                  dashboardVariables={dashboardVariables}
                  company={companyReducer}
                  financialyearid={
                    userPrefrenceandFY?.financialYear?.financialyearid
                  }
                  hideZeroBalance={hideRecToggleClicked}
                  hideGroupTotal={hideRecSumToggleClicked}
                />
                <Tooltip title="Expand/Collapse" arrow>
                  <Button
                    disableRipple
                    disableElevation
                    variant="outlined"
                    sx={{
                      color: expandRecClicked ? "#EDEDED" : "primary.main",
                      backgroundColor: expandRecClicked
                        ? "primary.main"
                        : "bodyGray.main",
                      fontSize: "12px",
                      border: "1px solid",
                      borderColor: "bodyGray.main",
                      height: "30px",
                      boxShadow: `
    inset 0 0 0.5px 1px hsla(0, 0%, 100%, 0.075),
    0 0 0 1px hsla(0, 0%, 0%, 0.05),
    0 0.3px 0.4px hsla(0, 0%, 0%, 0.02),
    0 0.9px 1.5px hsla(0, 0%, 0%, 0.045),
    0 3.5px 6px hsla(0, 0%, 0%, 0.09)`,
                      ":hover": {
                        color: "black",
                      },
                      minWidth: { xs: "50px", sm: "64px" },
                    }}
                    onClick={() => handleRecExpand()}
                  >
                    {expandRecClicked ? <CloseFullscreen /> : <OpenInFull />}
                  </Button>
                </Tooltip>

                <DbReloadBtn tab={getCurrentTab()} />
                <Button
                  sx={{
                    height: "30px",
                    width: { xs: "50px", sm: "64px" },
                    minWidth: "unset",
                  }}
                  variant="contained"
                  onClick={openMenuPL}
                >
                  <MoreVert />
                </Button>
              </Box>
            </Box> */}

            {/* <Box
              sx={{
                display: "flex",
                padding: "2px 0 8px 0",
                justifyContent: "flex-end",
              }}
            >
              <Box sx={{ display: "inline" }}></Box>
            </Box> */}
            <Box
              sx={{
                marginBottom: '20px',
                // borderRadius: 12,
                // backgroundColor: "bodyGray.main",
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', md: 'row' },
                  gap: 3,
                }}
              >
                <Box
                  sx={{
                    width: '100%',

                    borderRadius: '6px',
                    //                 boxShadow: `
                    // inset 0 0 0.5px 1px hsla(0, 0%, 100%, 0.075),
                    // 0 0 0 1px hsla(0, 0%, 0%, 0.05),
                    // 0 0.3px 0.4px hsla(0, 0%, 0%, 0.02),
                    // 0 0.9px 1.5px hsla(0, 0%, 0%, 0.045),
                    // 0 3.5px 6px hsla(0, 0%, 0%, 0.09)`,
                    overflow: 'scroll',
                    scrollbarWidth: 'none', // Firefox
                    '&::-webkit-scrollbar': {
                      display: 'none', // Chrome, Safari, etc.
                    },
                  }}
                >
                  <ReceivablesTable
                    heading={'Trade Receivables'}
                    rows={receivables}
                    headColor={'primary.main'}
                    shadowColor={theme.palette.shadow.primary}
                    expandButtonClicked={expandRecClicked}
                    hideZeroledger={hideRecToggleClicked}
                    hideGroup={hideRecSumToggleClicked}
                    setAccountID={setAccountID}
                    setNewLedgerResponse={setNewLedgerResponse}
                    newLedgerAccountID={newLedgerResponse}
                    renderTotalAgain={totalRecRender}
                    setRenderTotalAgain={settotalRecRender}
                    setSelectedParentId={setSelectedParentId}
                    refetchDb={refetchDashboard}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        )}
        {payableClicked && (
          <Box
            sx={{
              borderRadius: 4,
              // width: '100%',
              p: { sm: 1, xs: '4px 0' },
              paddingLeft: 1,
              //           boxShadow: `
              // inset 0 0 0.5px 1px hsla(0, 0%, 100%, 0.075),
              // 0 0 0 1px hsla(0, 0%, 0%, 0.05),
              // 0 0.3px 0.4px hsla(0, 0%, 0%, 0.02),
              // 0 0.9px 1.5px hsla(0, 0%, 0%, 0.045),
              // 0 3.5px 6px hsla(0, 0%, 0%, 0.09)`,
            }}
          >
            {/* <Box
              sx={{
                alignItems: "center",
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                justifyContent: { xs: "center", md: "space-between" },
                flexWrap: { md: "wrap" },
                gap: 1,
                pb: "10px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: { xs: "column", sm: "row" },
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <DashboardPeriodSelector
                    page="dateRange"
                    title="Period"
                  />
                  <Box sx={{ display: { xs: "block", sm: "none" } }}>
                    <AIBlinkButton
                      sx={{ marginTop: "0px" }}
                      onClick={async () => {
                        setAIModal(true);
                        setAIModalLoading(true);
                        const payload = {
                          tab_name: "profit and Loss",
                          data: aiPLData,
                        };
                        try {
                          const res = await axiosInstanceForLambda.post(
                            API_ENDPOINTS.REACT_APP_AIBLINK_URL,
                            payload
                          );
                          setAISummary(res.data.markdown_summary);
                          setAIModalLoading(false);
                          console.log(res, "res");
                        } catch (err) {
                          console.log(err, "err");
                          if (err) {
                            showWarningSnackbar(
                              "Something went wrong please try again"
                            );
                            setAIModalLoading(false);
                          }
                        }
                      }}
                    />
                  </Box>
                </Box>
                {!openingBalance?.ProfitAndLoss &&
                  DashboardOpWarning({ title: "profit & loss" })}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  marginRight: { xs: 0, md: 4 },
                }}
              >
                <Popover
                  id={id}
                  open={open}
                  anchorEl={anchorElPL}
                  onClose={closeMenuPL}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                >
                  <Box
                    sx={{ p: "5px", display: "flex", flexDirection: "column" }}
                  >
                    <FormControlLabel
                      value="Left"
                      control={
                        <Checkbox
                          checked={hidePayToggleClicked}
                          onChange={(e) => {
                            sethidePayToggleClicked(e.target.checked);
                          }}
                        />
                      }
                      label="Hide Ledgers With Zero Balance"
                      labelPlacement="end"
                      sx={{
                        ".MuiTypography-root": {
                          fontSize: "14px",
                        },
                        color: "shadow.primary",
                      }}
                    />
                    <FormControlLabel
                      value="Left"
                      control={
                        <Checkbox
                          checked={hidePaySumToggleClicked}
                          onChange={(e) => {
                            sethidePaySumToggleClicked(e.target.checked);
                          }}
                        />
                      }
                      label="Hide Group Totals"
                      labelPlacement="end"
                      sx={{
                        ".MuiTypography-root": {
                          fontSize: "14px",
                        },
                        color: "shadow.primary",
                      }}
                    />
                    <FormControlLabel
                      id="switch"
                      value="Left"
                      control={
                        <Checkbox
                          checked={openingBalance.trailBalance}
                          onChange={() => {
                            handleOpeningBalance("trailBalance");
                          }}
                        />
                      }
                      label="Include Opening balance"
                      labelPlacement="end"
                      sx={{
                        ".MuiTypography-root": {
                          fontSize: "14px",
                        },
                        color: "shadow.primary",
                      }}
                    />
                  </Box>
                </Popover>
              </Box>
              <Box
                sx={{
                  display: "inline-flex",
                  flexDirection: "row",
                  justifyContent: { xs: "center", md: "end" },
                  flexWrap: "wrap",
                  position: "sticky",
                  top: 80,
                  zIndex: 1,
                  gap: "5px",
                  m: { xs: 0, sm: 1 },
                  pr: { xs: "0px", sm: "20px" },
                }}
              >
                <Box sx={{ display: { xs: "none", sm: "block" } }}>
                  <AIBlinkButton
                    sx={{ marginTop: "-18px" }}
                    onClick={async () => {
                      setAIModal(true);
                      setAIModalLoading(true);
                      const payload = {
                        tab_name: "Payables",
                        data: aiPData,
                      };
                      try {
                        const res = await axiosInstanceForLambda.post(
                          API_ENDPOINTS.REACT_APP_AIBLINK_URL,
                          payload
                        );
                        setAISummary(res.data.markdown_summary);
                        setAIModalLoading(false);
                        console.log(res, "res");
                      } catch (err) {
                        console.log(err, "err");
                        if (err) {
                          showWarningSnackbar(
                            "Something went wrong please try again"
                          );
                          setAIModalLoading(false);
                        }
                      }
                    }}
                  />
                </Box>

                <Tooltip title="Print" arrow>
                  <Button
                    disableRipple
                    disableElevation
                    variant="outlined"
                    sx={{
                      color: "primary.main",
                      backgroundColor: "bodyGray.main",
                      fontSize: "12px",
                      border: "1px solid",
                      borderColor: "bodyGray.main",
                      boxShadow: `
    inset 0 0 0.5px 1px hsla(0, 0%, 100%, 0.075),
    0 0 0 1px hsla(0, 0%, 0%, 0.05),
    0 0.3px 0.4px hsla(0, 0%, 0%, 0.02),
    0 0.9px 1.5px hsla(0, 0%, 0%, 0.045),
    0 3.5px 6px hsla(0, 0%, 0%, 0.09)`,
                      height: "30px",
                      minWidth: { xs: "50px", sm: "64px" },
                    }}
                    onClick={() =>
                      generateDashboardPrintableTable(
                        {
                          rows: receivables,
                        },
                        [
                          { key: "name", label: "Account" },
                          { key: "amount", label: "Amount", align: "right" },
                        ],
                        "Payables",
                        "Payable",
                        companyReducer.companyName,
                        dashboardVariables,
                        {
                          hideGroupTotal: hidePaySumToggleClicked,
                          hideZeroBalLedger: hidePandLToggleClicked,
                        }
                      )
                    }
                  >
                    {<LocalPrintshop />}
                  </Button>
                </Tooltip>
                <DbExportButton
                  dbItem="Payables"
                  dashboardVariables={dashboardVariables}
                  company={companyReducer}
                  financialyearid={
                    userPrefrenceandFY?.financialYear?.financialyearid
                  }
                  hideZeroBalance={hidePandLToggleClicked}
                  hideGroupTotal={hidePaySumToggleClicked}
                />
                <Tooltip title="Expand/Collapse" arrow>
                  <Button
                    disableRipple
                    disableElevation
                    variant="outlined"
                    sx={{
                      color: expandPayClicked ? "#EDEDED" : "primary.main",
                      backgroundColor: expandPayClicked
                        ? "primary.main"
                        : "bodyGray.main",
                      fontSize: "12px",
                      border: "1px solid",
                      borderColor: "bodyGray.main",
                      boxShadow: `
    inset 0 0 0.5px 1px hsla(0, 0%, 100%, 0.075),
    0 0 0 1px hsla(0, 0%, 0%, 0.05),
    0 0.3px 0.4px hsla(0, 0%, 0%, 0.02),
    0 0.9px 1.5px hsla(0, 0%, 0%, 0.045),
    0 3.5px 6px hsla(0, 0%, 0%, 0.09)`,
                      height: "30px",
                      ":hover": {
                        color: "black",
                      },
                      minWidth: { xs: "50px", sm: "64px" },
                    }}
                    onClick={() => handlePayExpand()}
                  >
                    {expandPayClicked ? <CloseFullscreen /> : <OpenInFull />}
                  </Button>
                </Tooltip>

                <DbReloadBtn tab={getCurrentTab()} />
                <Button
                  sx={{
                    height: "30px",
                    width: { xs: "50px", sm: "64px" },
                    minWidth: "unset",
                  }}
                  variant="contained"
                  onClick={openMenuPL}
                >
                  <MoreVert />
                </Button>
              </Box>
            </Box> */}

            <Box
              sx={{
                padding: { sm: '0 10px 10px 10px', xs: '0 0px' },
                marginBottom: '20px',
                // borderRadius: 12,
                // backgroundColor: "bodyGray.main",
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', md: 'row' },
                  gap: 3,
                }}
              >
                <Box
                  sx={{
                    width: '100%',
                    borderRadius: '6px',
                    //                 boxShadow: `
                    // inset 0 0 0.5px 1px hsla(0, 0%, 100%, 0.075),
                    // 0 0 0 1px hsla(0, 0%, 0%, 0.05),
                    // 0 0.3px 0.4px hsla(0, 0%, 0%, 0.02),
                    // 0 0.9px 1.5px hsla(0, 0%, 0%, 0.045),
                    // 0 3.5px 6px hsla(0, 0%, 0%, 0.09)`,
                    scrollbarWidth: 'none', // For Firefox
                    '&::-webkit-scrollbar': {
                      display: 'none', // For Chrome, Safari
                    },
                  }}
                >
                  <ReceivablesTable
                    heading={'Trade Payables'}
                    rows={receivables}
                    hideZeroledger={hidePayToggleClicked}
                    hideGroup={hidePaySumToggleClicked}
                    headColor={'primary.main'}
                    shadowColor={theme.palette.shadow.primary}
                    expandButtonClicked={expandPayClicked}
                    hideAmount={hidePaySumToggleClicked}
                    setAccountID={setAccountID}
                    setNewLedgerResponse={setNewLedgerResponse}
                    newLedgerAccountID={newLedgerResponse}
                    setSelectedParentId={setSelectedParentId}
                    refetchDb={refetchDashboard}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        )}
        {trailBalanceClicked && (
          <Box
            sx={{
              borderRadius: 4,
              padding: { xs: '2px', sm: '8px' },
            }}
          >
            <Box
              sx={{
                marginBottom: '20px',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', md: 'row' },
                  gap: 3,
                }}
              >
                <Box
                  style={{
                    width: '100%',
                    borderRadius: 6,
                    overflow: 'scroll',
                  }}
                >
                  <TrailBalanceTable
                    heading={'Trial Balance'}
                    rows={TBrowsLiabilities}
                    openingBalanceDiff={openingDiffenerenceLedger}
                    setSelectedParentId={setSelectedParentId}
                    selectedParentId={selectedParentId}
                    headColor={'primary.main'}
                    shadowColor={theme.palette.shadow.primary}
                    expandButtonClicked={expandTBClicked}
                    totalCredit={totalCredit}
                    totalDebit={totalDebit}
                    hideAmount={hideSumToggleClicked}
                    hideZeroLedger={hideToggleClicked}
                    tbgroups={groups}
                    setAccountID={setAccountID}
                    setNewLedgerResponse={setNewLedgerResponse}
                    newLedgerAccountID={newLedgerResponse}
                    refetchDb={refetchDashboard}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        )}
        {itemsClicked && (
          <Box
            sx={{
              padding: { sm: '0 10px 10px 10px', xs: '0 0px' },
              marginBottom: '20px',
              // borderRadius: 12,
              // backgroundColor: "bodyGray.main",
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                gap: 3,
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  padding: '1px',
                  borderRadius: '6px',
                }}
              >
                <ItemNewTable
                  expandButtonClicked={expandItemClicked}
                  setItemRow={setItemRow}
                  hideZeroBalance={tabKey?.hideZeroLedgerState}
                  hideGroupTotal={tabKey?.hideGroupTotal}
                  // itemSearchText={itemSearchText}
                  // itemfilterItem={searchFilterItems}
                />
              </Box>
            </Box>
          </Box>
        )}
      </Box>
      <SimpleModal open={aiModal} setOpen={setAIModal} title={'AI Insights'} body={aisummary} aiModalLoading={aiModalLoading} />
      <ExportModal
        open={exportModalOpen}
        onClose={handleExportModalClose}
        onExport={handleExport}
        tabName={tabKey?.tab_name || 'Dashboard'}
        currentStartDate={dashboardVariables.current?.startdate}
        currentEndDate={dashboardVariables.current?.enddate}
        loading={exportLoading}
      />
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isInitialDataLoading || isLoading || isLoadingClosingStock || backdropOpen}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {!backdropOpen && transactionModalParams.accountId && <LedgerTransactionModalv2 {...transactionModalParams} />}
      {localStorage.getItem('screenRotate') && matches && <RotateScreen openRotate={openRotate} setOpenRotate={setOpenRotate} />}
    </Box>
  );
}

export default DashboardHome;

const DashboardOpWarning = ({ title }) => {
  return (
    <Box display="flex" alignItems="center" sx={{ marginLeft: '12px' }}>
      <WarningAmber color="warning" sx={{ fontSize: 18, marginRight: '2px' }} />
      <Typography variant="body1" color="warning.main" sx={{ fontSize: '13px' }}>
        Opening balances are not included in the {title}.
      </Typography>
    </Box>
  );
};
